// extracted by mini-css-extract-plugin
module.exports = {"code":"f_h"};